module.exports = __webpack_public_path__ + "img/growth2.5b26618f.jpg";